export default __webpack_public_path__ + "static/media/products_314.930de4ed.jpg";